<template>
  <v-dialog v-model="dialog" max-width="450" :persistent="load">
    <v-card :disabled="load">
      <v-card-title>
        {{ $store.state.isImpersonating ? 'Usando como otro usuario' : 'Usar como' }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <!-- Estado de impersonación activa -->
        <v-alert v-if="$store.state.isImpersonating" type="warning" text class="mb-4">
          Estás usando como <strong>{{ $store.state.impersonatedTarget }}</strong>
        </v-alert>

        <!-- Autocomplete (solo cuando no está impersonando) -->
        <v-form v-if="!$store.state.isImpersonating" ref="form" @submit.prevent="usarComo()">
          <v-autocomplete
            v-model="selectedUser"
            :items="usuarios"
            item-text="nombre_completo"
            item-value="id"
            label="Buscar usuario"
            placeholder="Escribí para filtrar..."
            :loading="loading"
            no-data-text="No se encontraron usuarios"
            return-object
            clearable
            autofocus
            prepend-icon="fas fa-search"
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.nombre_completo }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.username }} — {{ item.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
            <template v-slot:selection="{ item }">
              {{ item.nombre_completo }}
              <span class="grey--text caption ml-1">({{ item.username }})</span>
            </template>
          </v-autocomplete>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Cancelar</v-btn>
        <v-btn
          v-if="!$store.state.isImpersonating"
          color="primary"
          :disabled="!selectedUser"
          :loading="load"
          @click="usarComo()"
        >
          Usar como
        </v-btn>
        <v-btn
          v-else
          color="warning"
          :loading="load"
          @click="dejarDeUsar()"
        >
          Dejar de usar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      selectedUser: null,
      usuarios: [],
      loading: false,
      load: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(val) {
      if (val && !this.$store.state.isImpersonating) {
        this.selectedUser = null
        this.cargarUsuarios()
      }
    }
  },
  mounted() {
    this.cargarUsuarios()
  },
  methods: {
    async cargarUsuarios() {
      this.loading = true
      try {
        const data = await this.$store.dispatch('usuarios/get_usuarios', {
          inhabilitado: 0
        })
        this.usuarios = data.data
      } catch (error) {
        this.$store.dispatch('show_snackbar', {
          text: 'Error al cargar usuarios',
          color: 'error'
        })
      }
      this.loading = false
    },
    async usarComo() {
      if (!this.selectedUser) return
      this.load = true
      this.$store.state.loading = true
      await this.$store.dispatch('impersonate', this.selectedUser.id)
        .then(() => {
          this.$store.dispatch('show_snackbar', {
            text: `Ahora estás usando como ${this.selectedUser.nombre_completo}`,
            color: 'success'
          })
          window.location.reload(true)
        })
        .catch((error) => {
          this.$store.dispatch('show_snackbar', {
            text: error.message || 'Error al usar como',
            color: 'error'
          })
        })
      this.load = false
      this.$store.state.loading = false
    },
    async dejarDeUsar() {
      this.load = true
      this.$store.state.loading = true
      await this.$store.dispatch('stopImpersonating')
        .then(() => {
          this.$store.dispatch('show_snackbar', {
            text: 'Sesión restaurada correctamente',
            color: 'success'
          })
          window.location.reload(true)
        })
        .catch((error) => {
          this.$store.dispatch('show_snackbar', {
            text: error.message || 'Error al dejar de usar',
            color: 'error'
          })
        })
      this.load = false
      this.$store.state.loading = false
    }
  }
}
</script>
